import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "Dianzanhou"
});
const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  d: "M9.2 6.19989V3.79989C9.2 2.80576 8.39413 1.99988 7.4 1.99988L5 7.39989V13.9999H11.972C12.5704 14.0067 13.0823 13.5715 13.172 12.9799L14 7.57989C14.0528 7.23179 13.9501 6.87805 13.7191 6.61239C13.4881 6.34672 13.1521 6.19589 12.8 6.19989H9.2Z",
  fill: "#FFA755",
  stroke: "#FFA755",
  "stroke-width": "1.33333",
  "stroke-linejoin": "round"
}, null, -1);
const _hoisted_3 = /* @__PURE__ */ createElementVNode("path", {
  d: "M5 7.33345H3.398C2.69511 7.32101 2.09423 7.90325 2 8.59988V12.7999C2.09423 13.4965 2.69511 14.0123 3.398 13.9999H5V7.33345Z",
  fill: "#FFA755",
  stroke: "#FFA755",
  "stroke-width": "1.33333",
  "stroke-linejoin": "round"
}, null, -1);
const _hoisted_4 = /* @__PURE__ */ createElementVNode("rect", {
  x: "3",
  y: "8.66638",
  width: "1",
  height: "4",
  rx: "0.5",
  fill: "white"
}, null, -1);
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_5);
}
var dianzanhou = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { dianzanhou as default };
